import { Component, computed, inject } from '@angular/core';
import { MarkdownComponent, provideMarkdown } from 'ngx-markdown';

import { FinParcoursStore } from '../../store/fin-parcours/fin-parcours.store';

@Component({
  selector: 'app-fin-parcours-detail-contenu',
  imports: [MarkdownComponent],
  templateUrl: './fin-parcours-detail-contenu.component.html',
  providers: [provideMarkdown()],
})
export class FinParcoursDetailContenuComponent {
  readonly #finParcoursStore = inject(FinParcoursStore);
  readonly finParcours = computed(() => this.#finParcoursStore.selectedEntity());
}
